<template>
    <v-card
        @click="openOrganisation()"
        class="organisation-card"
        elevation="0"
    >
        <v-card-text class="pa-5 pa-md-6">
            <h2 class="text-h5 mb-4 primary--text">
                {{ organisation.mainActivity }}
            </h2>
            <v-row class="align-start my-0 pb-4">
                <v-col class="col-12 col-md-6 py-0 mb-4 mb-md-0 d-flex">
                    <v-avatar
                        class="mr-2 avatar-contain"
                        size="48"
                        v-if="organisation.logo"
                        rounded="0"
                    >
                        <img
                            :src="organisation.logo.url"
                            :alt="organisation.name"
                        >
                    </v-avatar>
                    <p class="mt-2">{{ organisation.name }}</p>
                </v-col>
                <v-col class="col-9 col-md-4 py-0">
                    <ul class="list-unstyled details">
                        <li class="mb-2">
                            <v-icon
                                small
                                color="secondary"
                                class="mr-1 fa-fw"
                            >
                                far fa-envelope
                            </v-icon>
                            {{ organisation.email }}
                        </li>
                        <li class="mb-2">
                            <v-icon
                                small
                                color="secondary"
                                class="mr-1 fa-fw"
                            >
                                far fa-phone
                            </v-icon>
                            {{ organisation.phoneNumber }}
                        </li>
                    </ul>
                </v-col>
                <v-col class="col-3 col-md-2 py-0 my-auto text-right">
                    <v-btn
                        fab
                        color="primary"
                        dark
                        elevation="0"
                    >
                        <v-icon>
                            fas fa-angle-double-right
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <p class="text--secondary" v-if="planning">
                <v-icon
                    small
                    color="secondary"
                    class="mr-1 fa-fw"
                >
                    far fa-calendar
                </v-icon>
                {{ planning }}
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
import {formatPlanning} from "@/utils/formatters";

export default {
    name: "OrganisationCard",
    props: {
        organisation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        planning () {
            return formatPlanning(this.organisation);
        },
    },
    methods: {
        openOrganisation () {
            this.$router.push({name: 'Organisation', params: { uuid: this.organisation.uuid }});
        },
    },
}
</script>

<style scoped>

</style>
